import axiosClient from "api/apiClient";

interface IOptions {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    isArchived: boolean;
}

export const APIGetClassrooms = (options: IOptions) => {
    let sort = "";
    let search = "";
    if (options.hasOwnProperty("sort")) {
        if (options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.isArchived) {
      return axiosClient.post(`/classrooms/archived${options.page}${search}${sort}`);
    }

    return axiosClient.get(`/classrooms${options.page}${search}${sort}`);
};

export const APIGetAllClassrooms = () => {
    return axiosClient.post(`/classrooms/all`);
};

export const APIPostClassroomsMany = (data: object) => {
    return axiosClient.post(`/classrooms/show-manny`, data);
}
